import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/components/VersionSwitch/NamedVersions/namedVersions.styled.ts",
    _templateObject2,
    _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
export var OnlyNamedWrap = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin: 0 24px;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  user-select: none;\n  gap: 0 8px;\n\n  ", "\n"])), function (props) {
  return props.disabled && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      cursor: default;\n      pointer-events: none;\n      opacity: 0.2;\n    "])));
});
export var OnlyNamedText = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #000335;\n"])));